import React from "react"

import { gql, useQuery } from "@apollo/client"
import { Formik, Form } from "formik"
import * as yup from "yup"

import { Fieldset, Modal } from "components"

import uniqBy from "lodash/uniqBy"
import { toast } from "react-hot-toast"
import { uri } from "config"

const SendEmailModal = ({ initialValues, bcc, isOpen, onClose, onSubmit }) => {
  const sendEmailSchema = yup.object().shape({
    subject: yup.string().required("Full name is reqiured"),
    body: yup.string().required("Full name is reqiured"),
    to: yup
      .array()
      .of(
        yup
          .string()
          .email("E-mail is not valid!")
          .required("E-mail is required!"),
      ),

    // password: yup.string().required("Password name is reqiured"),
    // phoneNumber: yup.string(),
    // role: yup.object().shape({
    //   value: yup.string().required("Role is required"),
    // }),
  })

  const formikProps = {
    initialValues: { to: "", subject: "", body: ",", ...initialValues },
    validateOnBlur: false,
    validateOnChange: false,
    // validationSchema: sendEmailSchema,
    onSubmit: async (values, { props, resetForm, setErrors }) => {
      try {
        const input = {
          ...values,
          to: Array.isArray(values?.to)
            ? values?.to?.map((person) =>
                person?.value?.email ? person?.value?.email : person?.value,
              )
            : values.to,
        }

        await toast.promise(
          fetch(`${uri}/notification/email`, {
            method: "POST",
            body: JSON.stringify(input),
            headers: { "Content-Type": "application/json" },
          }),
          {
            loading: "Sending Email...",
            success: <b>Email sent!</b>,
            error: <b>Could not save.</b>,
          },
        )

        // await onSubmit(input)
        await onClose()
      } catch (error) {
        console.error(error)
        setErrors(error)
      }
    },
  }

  return (
    <Modal title="Send Email" isOpen={isOpen} onClose={onClose}>
      <div className="max-w-screen-lg mx-auto">
        <Formik {...formikProps}>
          {({ isSubmitting }) => (
            <Form>
              <div className="py-3">
                <InputUser isMulti={bcc} />
              </div>
              <div className="py-3">
                <Fieldset label="Subject" type="text" name="subject" />
              </div>
              <div className="py-3">
                <Fieldset label="Body" component="textarea" name="body" />
              </div>

              <ModalNavigation {...{ isSubmitting, onClose }} />
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default SendEmailModal

const ModalNavigation = ({ isSubmitting, onClose }) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <button
          disabled={isSubmitting}
          type="submit"
          className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
        >
          Send
        </button>
      </span>

      <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          onClick={onClose}
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Cancel
        </button>
      </span>
    </div>
  )
}

const InputUser = ({ isMulti }) => {
  const USERS = gql`
    query Users(
      $filter: UserFilterInput
      $page: Int
      $size: Int
      $sort: UserSortInput
    ) {
      users(filter: $filter, page: $page, size: $size, sort: $sort) {
        id
        displayName
        email
      }
    }
  `

  const variables = {
    page: 0,
    size: 10,
    filter: { roles: ["ADMIN", "AGENT", "LEADER"] },
    sort: { displayName: "ASC" },
  }

  const { data, loading, fetchMore } = useQuery(USERS, {
    variables,
    // notifyOnNetworkStatusChange: true,
  })

  const users = data?.users?.map((user) => ({
    key: user.id,
    label: user.displayName,
    value: { ...user },
  }))

  const handleSearch = (_search, e) => {
    if (e.action === "input-change") {
      const search = _search?.toLowerCase()
      fetchMore({
        variables: { ...variables, filter: { ...variables.filter, search } },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          return Object.assign({}, prev, {
            users: uniqBy(
              [...prev.users, ...fetchMoreResult.users],
              "displayName",
            ),
          })
        },
      })
    }
  }

  return (
    <Fieldset
      name="to"
      label="To *"
      component="select"
      options={users}
      cacheOptions
      isCreatable
      isMulti={isMulti}
      isLoading={loading}
      onInputChange={handleSearch}
      getOptionValue={(opt) => opt.key}
      mapping={{ label: "displayName" }}
      placeholder="To"
    />
  )
}
